module.exports = "<footer class=\"footer\">\r\n  <div class=\"container\">\r\n    <a class=\"logo-font\" routerLink=\"/\">VUY</a>\r\n    <span class=\"attribution\" style=\"color:white\">\r\n      &copy; {{ hoy | date }}.\r\n      Una aplicación web desarrollada por Samuel Sánchez.\r\n    </span>\r\n  </div>\r\n</footer>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/componentes/layout/footer.component.html
// module id = ./src/app/componentes/layout/footer.component.html
// module chunks = main